import { ref } from 'vue'
import rankingBackOne from '@/assets/images/ranking-back-one.png'
import rankingBackTwo from '@/assets/images/ranking-back-two.png'
import rankingBackThree from '@/assets/images/ranking-back-three.png'
import rankingBackFour from '@/assets/images/ranking-back-four.png'
import rankingBackFive from '@/assets/images/ranking-back-five.png'
import back1Image from '@/assets/images/newhouse/themefindroom/back1.png'
import back2Image from '@/assets/images/newhouse/themefindroom/back2.png'
import back3Image from '@/assets/images/newhouse/themefindroom/back3.png'
import back4Image from '@/assets/images/newhouse/themefindroom/back4.png'
import back5Image from '@/assets/images/newhouse/themefindroom/back5.png'
import back6Image from '@/assets/images/newhouse/themefindroom/back6.png'
import back7Image from '@/assets/images/newhouse/themefindroom/back7.png'
import back8Image from '@/assets/images/newhouse/themefindroom/back8.png'
import back9Image from '@/assets/images/newhouse/themefindroom/back9.png'
import back10Image from '@/assets/images/newhouse/themefindroom/back10.png'

interface tab {
  name: string
  url: string
  [key: string]: any
}

interface rankingTabType {
  name: string
  back: any
  type?: number
  [key: string]: any
}

interface BannerType {
  title: string
  url: string
  backImage: string
  describe: string
}

export function useTabList() {
  const route = useRoute()
  const floorId = computed(() => route.params.floorId)
  const tabList = ref<tab[]>([
    {
      name: '楼盘大全',
      url: '/newhouse/',
    },
    {
      name: '主题找房',
      url: '/newhouse/themefindroom.html',
    },
    {
      name: '品牌找房',
      url: '/newhouse/brandfindroom/brandlist.html',
    },
    {
      name: '看房团',
      url: '/newhouse/kanfang.html',
    },
    {
      name: '智能找房',
      url: '/newhouse/ai.html',
    },
    {
      name: '新房榜单',
      url: '/newhouse/ranking.html',
    },
  ])
  const rankingTabList = ref<rankingTabType[]>([
    {
      name: '荣誉榜',
      back: rankingBackFour,
      url: '/newhouse/ranking_3.html',
      rankingTypeId: 3,
    },
    {
      name: '热搜榜',
      back: rankingBackTwo,
      url: '/newhouse/ranking_2.html',
      rankingTypeId: 2,
    },
    {
      name: '人气榜',
      back: rankingBackThree,
      url: '/newhouse/ranking_1.html',
      rankingTypeId: 1,
    },
    {
      name: '品质榜',
      back: rankingBackOne,
      url: '/newhouse/ranking_4.html',
      rankingTypeId: 4,
    },
    {
      name: '关注榜',
      back: rankingBackFive,
      url: '/newhouse/ranking_5.html',
      rankingTypeId: 5,
    },
  ])
  const themeBannerList = ref<BannerType[]>([
    // 优惠楼盘、低密度住宅、拎包入住、3D看房、一房一价、近期开盘、现房交付、改善置业、视频看房、毛坯交付
    {
      title: '优惠楼盘',
      url: '/newhouse/themefindroom_1.html',
      backImage: back1Image,
      describe: '精选好房，特惠来袭',
    },
    {
      title: '低密度住宅',
      url: '/newhouse/themefindroom_2.html',
      backImage: back2Image,
      describe: '推窗即景，向阳而生',
    },
    {
      title: '拎包入住',
      url: '/newhouse/themefindroom_3.html',
      backImage: back3Image,
      describe: '拎包即住，省心便捷新体验',
    },
    {
      title: '3D看房',
      url: '/newhouse/themefindroom_4.html',
      backImage: back4Image,
      describe: '3D看房，全景尽在眼前',
    },
    {
      title: '一房一价',
      url: '/newhouse/themefindroom_5.html',
      backImage: back5Image,
      describe: '品质房源随心选',
    },
    {
      title: '近期开盘',
      url: '/newhouse/themefindroom_6.html',
      backImage: back6Image,
      describe: '开盘盛启，抢占先机',
    },
    {
      title: '现房交付',
      url: '/newhouse/themefindroom_7.html',
      backImage: back7Image,
      describe: '品质交付，幸福触手可及',
    },
    {
      title: '改善置业',
      url: '/newhouse/themefindroom_8.html',
      backImage: back8Image,
      describe: '改善升级，置业新篇章',
    },
    {
      title: '视频看房',
      url: '/newhouse/themefindroom_9.html',
      backImage: back9Image,
      describe: '身临其境，感受家的魅力',
    },
    {
      title: '毛坯交付',
      url: '/newhouse/themefindroom_10.html',
      backImage: back10Image,
      describe: '毛坯交付，自由打造梦想家',
    },
  ])
  const tabMenu = ref<tab[]>([
    {
      name: '楼盘首页', // √
      url: `/newhouse/${floorId.value}/index.html`,
      showKey: 'indexPage',
      tabActive: 0,
    },
    {
      name: '楼盘详情', // √
      url: `/newhouse/${floorId.value}/brief.html`,
      showKey: 'detailPage',
      tabActive: 1,
    },
    {
      name: '楼盘相册', // √
      url: `/newhouse/${floorId.value}/photo.html`,
      showKey: 'photoPage',
      tabActive: 2,
    },
    {
      name: '楼盘户型', // √
      url: `/newhouse/${floorId.value}/model.html`,
      showKey: 'modelPage',
      tabActive: 3,
    },
    {
      name: '房博士评楼', // √
      url: `/newhouse/floorEvaluating/${floorId.value}.html`,
      showKey: 'evaluatePage',
      tabActive: 4,
    },
    {
      name: '楼栋信息', // √
      url: `/newhouse/oneprice/${floorId.value}.html`,
      showKey: 'buildingPage',
      tabActive: 6,
    },
    {
      name: '楼盘动态', // √
      url: `/newhouse/${floorId.value}/news.html`,
      showKey: 'newsPage',
      tabActive: 8,
    },
    {
      name: '周边配套', // √
      url: `/newhouse/mapdetail/${floorId.value}/index.html`,
      showKey: 'surroundingPage',
      tabActive: 7,
    },
    {
      name: '房价分析', // √
      url: `/newhouse/${floorId.value}/price.html`,
      showKey: 'pricePage',
      tabActive: 5,
    },
  ])
  const lookHouseList = ref<tab[]>([
    {
      name: '看房行程',
      url: '#step1',
    },
    {
      name: '活动规则',
      url: '#step2',
    },
    {
      name: '楼盘地址',
      url: '#step3',
    },
    {
      name: '免责声明',
      url: '#step4',
    },
  ])
  return {
    tabList,
    rankingTabList,
    themeBannerList,
    tabMenu,
    lookHouseList,
  }
}
